<!-- Header -->
<div *ngIf="module && !courseComplete" class="header">
    <!-- Title -->
    <h1 class="header-title text-center">Module {{module.moduleNumber}} - {{module.title}}</h1>

    <!-- Admin Header -->
    <div *ngIf="previewByAdmin && page <= modulePages.length" class="admin-header text-center">
      <!-- Back -->
      <div class="back-to-admin">
        <button type="button" class="back btn custom text-primary" (click)="goBackToAdmin()"><mdb-icon fas icon="arrow-circle-left"></mdb-icon> Back to List</button>
      </div>

      <h2>
        <!-- Page -->
        <span>Page {{page}} / {{modulePages.length}}</span>

        <!-- Edit -->
        <a [routerLink]="" (click)="editPage()" class="edit-link ml-4">[Edit]</a>
      </h2>
    </div>
</div>

<!-- Module Content -->
<ng-container *ngIf="page <= modulePages.length && !courseComplete">

  <section *ngIf="!modulePage || (modulePage.type === 'Custom' && !loading)">
    <app-module-page-rw #p [content]="modulePage" (back)="back($event)" (next)="next($event)" [nextTitle]="nextTitle" [delay]="delayNext"></app-module-page-rw>
  </section>

  <section *ngIf="modulePage && modulePage.type !== 'Custom' && modulePage.content === '[app-page-activity-flipping-cards-for-positive-communication-rw]'">
    <app-page-activity-flipping-cards-for-positive-communication-rw (back)="back($event)" (next)="next($event)" [nextTitle]="nextTitle" [delay]="delayNext"></app-page-activity-flipping-cards-for-positive-communication-rw>
  </section>

  <section *ngIf="modulePage && modulePage.type !== 'Custom' && modulePage.content === '[app-page-activity-simple-quiz-problem-reporting-rw]'">
    <app-page-activity-simple-quiz-problem-reporting-rw (back)="back($event)" (next)="next($event)" [nextTitle]="nextTitle" [delay]="delayNext"></app-page-activity-simple-quiz-problem-reporting-rw>
  </section>

  <section *ngIf="modulePage && modulePage.type !== 'Custom' && modulePage.content === '[app-page-activity-simple-quiz-whos-responsible-rw]'">
    <app-page-activity-simple-quiz-whos-responsible-rw (back)="back($event)" (next)="next($event)" [nextTitle]="nextTitle" [delay]="delayNext"></app-page-activity-simple-quiz-whos-responsible-rw>
  </section>

  <section *ngIf="modulePage && modulePage.type !== 'Custom' && modulePage.content === '[app-page-activities-rw]'">
    <app-page-activities-rw (back)="back($event)" (next)="next($event)" [nextTitle]="nextTitle" [delay]="delayNext"></app-page-activities-rw>
  </section>

  <section *ngIf="modulePage && modulePage.type !== 'Custom' && modulePage.content === '[app-page-activity-budgeting-quiz-rw]'">
    <app-page-activity-budgeting-quiz-rw (back)="back($event)" (next)="next($event)" [nextTitle]="nextTitle" [delay]="delayNext"></app-page-activity-budgeting-quiz-rw>
  </section>

  <section *ngIf="modulePage && modulePage.type !== 'Custom' && modulePage.content === '[app-page-activity-compare-three-housing-units-rw]'">
    <app-page-activity-compare-three-housing-units-rw (back)="back($event)" (next)="next($event)" [nextTitle]="nextTitle" [delay]="delayNext"></app-page-activity-compare-three-housing-units-rw>
  </section>

  <section *ngIf="modulePage && modulePage.type !== 'Custom' && modulePage.content === '[app-page-sample-credit-report-order-rw]'">
    <app-page-sample-credit-report-order-rw (back)="back($event)" (next)="next($event)" [nextTitle]="nextTitle" [delay]="delayNext"></app-page-sample-credit-report-order-rw>
  </section>

  <section *ngIf="modulePage && modulePage.type !== 'Custom' && modulePage.content === '[app-page-sample-letter-about-incorrect-credit-report-rw]'">
    <app-page-sample-letter-about-incorrect-credit-report-rw (back)="back($event)" (next)="next($event)" [nextTitle]="nextTitle" [delay]="delayNext"></app-page-sample-letter-about-incorrect-credit-report-rw>
  </section>

  <section *ngIf="modulePage && modulePage.type !== 'Custom' && modulePage.content === '[app-page-activity-review-lease-agreement-and-answer-rw]'">
    <app-page-activity-review-lease-agreement-and-answer-rw (back)="back($event)" (next)="next($event)" [nextTitle]="nextTitle" [delay]="delayNext"></app-page-activity-review-lease-agreement-and-answer-rw>
  </section>

  <section *ngIf="modulePage && modulePage.type !== 'Custom' && modulePage.content === '[app-page-activity-simple-quiz-moving-on-rw]'">
    <app-page-activity-simple-quiz-moving-on-rw (back)="back($event)" (next)="next($event)" [nextTitle]="nextTitle" [delay]="delayNext"></app-page-activity-simple-quiz-moving-on-rw>
  </section>

  <section *ngIf="modulePage && modulePage.type !== 'Custom' && modulePage.content === '[app-page-activity-estimating-monthly-income-nancy-rw]'">
    <app-page-activity-estimating-monthly-income-nancy-rw (back)="back($event)" (next)="next($event)" [nextTitle]="nextTitle" [delay]="delayNext"></app-page-activity-estimating-monthly-income-nancy-rw>
  </section>

  <section *ngIf="modulePage && modulePage.type !== 'Custom' && modulePage.content === '[app-page-activity-estimating-monthly-expenses-nancy-rw]'">
    <app-page-activity-estimating-monthly-expenses-nancy-rw (back)="back($event)" (next)="next($event)" [nextTitle]="nextTitle" [delay]="delayNext"></app-page-activity-estimating-monthly-expenses-nancy-rw>
  </section>

  <section *ngIf="modulePage && modulePage.type !== 'Custom' && modulePage.content === '[app-page-activity-needs-vs-wants-rw]'">
    <app-page-activity-needs-vs-wants-rw (back)="back($event)" (next)="next($event)" [nextTitle]="nextTitle" [delay]="delayNext"></app-page-activity-needs-vs-wants-rw>
  </section>

</ng-container>

<!-- Quiz Questions -->
<section *ngIf="page > modulePages.length && module?.endingQuiz && !courseComplete">
    <app-quiz-questions [questions]="questions" [moduleNumber]="moduleNumber" (quizSubmitted)="handleQuiz($event)"></app-quiz-questions>
</section>

<!-- Course Complete -->
<section *ngIf="previewByAdmin ? false : page > modulePages.length && !module?.endingQuiz || courseComplete">

  <!-- Message -->
  <div class="text-center">
      <h1 style="margin-bottom: 20px;">Congratulations! You've completed RentWise.</h1>
      <h4 style="margin-bottom: 60px;">Click 'Get Certificate' to receive your personalized certificate.</h4>

      <h4 style="margin-bottom: 20px; margin-top: 40px;" *ngIf="user.ageUnder18 !== true">You may now add properties you rent. Click 'Add Properties' to get started.</h4>
      <h5 style="margin-bottom: 60px;">If you are a tenant who took this for your own education, Thank you for learning more, but no other action is needed.</h5>

      <!-- Navigation Buttons -->
      <div class="certificate-btns">
          <button type="button" class="btn waves-dark w-25" (click)="backFromCompleted($event)"><i class="fas fa-angle-left mr-3"></i>Back</button>
          <button type="button" class="btn waves-dark w-25" [routerLink]="'../../properties'" *ngIf="user.ageUnder18 !== true">Add Properties</button>
          <button type="button" class="btn waves-dark w-25" [routerLink]="'../../certificate'">Get Certificate<i class="fas fa-angle-right ml-3"></i></button>
      </div>
  </div>
</section>
